import React from "react";
import { Box, Card, Divider, TableBody } from "@mui/material";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Sample from "../../AdminDashboard/Onsite And Offsite/Sample.json";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import Paginator from "../../../toolkit/Paginator";
import RightArrowOpen from "../../../icons/RightArrowOpen.svg";
import Edit from "../../../icons/edit.svg";
import Trash from "../../../icons/trash1.svg";
import Avatar from "../../../icons/Avatar.svg";
import Restoreicon from "../../../icons/Restoreicon.svg";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { useState, useLayoutEffect, useEffect, useContext } from "react";
import { useSearchParams } from "react-router-dom";
import { MenuItem } from "@mui/material";
import Select from "@mui/material/Select";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import useFetch from "../../../utils/useFetch";
import EmptyComponent from "../../../utils/EmptyComponent";
import CollectionsTemplate from "../../../components/CollectionsTemplate/index";
import { isArray } from "lodash";
import CompanyListItem from "./CompanyListItem";
import CompanyCollectionControls from "./CompanyCollectionControls";
import BaseURL from "../../../utils/base-uri.json";
import { CompaniesContext } from "../../../store/companies-context";
const pageSize = 12;

function companiesDataAdaptor(data) {
  return {
    headers: [
      { id: "CompanyName", text: "Name", width: "40%" },
      { id: "Role", text: "System Role", width: "50%" },
      { id: "icon", width: "2%" },
      { id: "icons", width: "5%" },
    ],
    isEditable: {
      callback: (item) => { },
      isVisible: true,
    },
    isDeletable: {
      callback: (item) => { },
      isVisible: true,
    },
    rows: data?.data?.map((d) =>
      Object.assign({}, d, {
        key: d.organizationID,
      })
    ),
    statusRoleMap: {
      Active: {
        role: "success",
      },
      InActive: {
        role: "error",
      },
    },
  };
}

function toQueryString(obj) {
  return "?".concat(
    Object.keys(obj)
      .map((e) => {
        if (isArray(obj[e])) {
          var d = obj[e]?.map(
            (r, idx) => `${e}[${idx}]=${encodeURIComponent(r)}`
          );
          return d.join("&");
        }
        return obj[e]
          ? `${encodeURIComponent(e)}=${encodeURIComponent(obj[e])}`
          : null;
      })
      .filter((e) => !!e)
      .join("&")
  );
}

function getUrl(url, data) {
  return `${url}${toQueryString(data)}`;
}

export default function Companies() {
  const { orgTypes, sortOrder } = useContext(CompaniesContext);

  let filteredOrgTypes = orgTypes;
  const queryUrl = BaseURL.baseUrl + BaseURL.Companies.GetCompanies;
  const [viewType, setViewType] = useState("list");
  const [filterObj, setFilterObj] = useState({});
  const [pageCount, setPageCount] = useState(1);
  const [collection, setCollection] = useState({});
  const [pageNumber, setPageNumber] = useState(1);
  const [Count, setCount] = useState("");
  const [selectedOrgTypes, setSelectedOrgTypes] = useState(["All"]);

  const [paramsState, setParamsState] = useState({
    companyName: "",
    isDownloadRequest: false,
    pageSize: pageSize,
    pageNumber: 1,
    typeClient: true,
    typeAdmin: true,
    typeVendor: true,
    sortOrder: "asc",
    sortColumn: "Name",
  });
  const [url, setUrl] = useState(
    getUrl(queryUrl, { ...paramsState, pageSize })
  );

  const { data: collectionData, loading, error } = useFetch(url);

  useLayoutEffect(() => {
    setUrl(getUrl(queryUrl, { ...paramsState, pageSize, ...filterObj }));
  }, [paramsState]);

  useLayoutEffect(() => {
    if (collectionData) {
      setCount(collectionData?.count);
      setPageCount(Math.ceil((collectionData.count || pageSize) / pageSize));
      setCollection(
        companiesDataAdaptor
          ? companiesDataAdaptor(collectionData)
          : collectionData
      );
    }
  }, [collectionData]);

  const filterChangeHandler = (obj) => {
    setFilterObj(obj);
    // setUrl(getUrl(queryUrl, { ...paramsState, pageSize, ...filterObj }));
  };
  useLayoutEffect(() => {
    setUrl(getUrl(queryUrl, { ...paramsState, pageSize, ...filterObj }));
  }, [filterObj]);

  useEffect(() => {
    setParamsState({
      ...paramsState,
      sortOrder: sortOrder,
      pageNumber: 1,
    });
  }, [sortOrder]);
  function toggleViewType() {
    setViewType(viewType === "list" ? "grid" : "list");
  }

  function setSearchStr(str) {
    setParamsState({
      ...paramsState,
      companyName: str,
      typeClient: str.length > 2,
      pageNumber: 1,
      typeClient: selectedOrgTypes.includes("Client"),
      typeVendor: selectedOrgTypes.includes("Vendor"),
      typeAdmin: selectedOrgTypes.includes("Admin"),
    });
  }
  function setCompanyType(types) {
    const updatedTypes =
      types.includes("Client") ||
      types.includes("Vendor") ||
      types.includes("Admin")
        ? types.filter((type) => type !== "All")
        : ["All"];

    if (!selectedOrgTypes.includes("All") && types.includes("All")) {
        orgTypeAllSelected();
        return;
    }
    setSelectedOrgTypes(updatedTypes);

    setParamsState({
      ...paramsState,
      typeClient: types.includes("Client"),
      typeVendor: types.includes("Vendor"),
      typeAdmin: types.includes("Admin"),
      pageNumber: 1,
    });
  }
  function setPage(pageNumber) {
    setPageNumber(pageNumber);
    setParamsState((prev) => ({ ...prev, pageNumber }));
  }

  const orgTypeAllSelected = () => {
    setParamsState({
      ...paramsState,
      typeClient: true,
      typeVendor: true,
      typeAdmin: true,
      pageNumber: 1,
    });
    setSelectedOrgTypes(["All"]);

  };


  return (
    <>
      <CollectionsTemplate
        TitlebarChildren={EmptyComponent}
        page={paramsState.pageNumber}
        setPage={setPage}
        pageCount={pageCount}
        fetchState={{ loading, error }}
        collection={collection}
        viewType={viewType}
        responseDataAdaptor={companiesDataAdaptor}
        ListItemComponent={CompanyListItem}
        GridItemComponent={EmptyComponent}
        SlidingPopupTitle="User Filters"
        RecCount={Count}
        SlidingPopupContent={<EmptyComponent />}
        CollectionControls={(props) => (
          <CompanyCollectionControls
            setSearchStr={setSearchStr}
            searchStr={paramsState.companyName}
            orgTypes={orgTypes}
            setCompanyType={setCompanyType}
            selectedOrgTypes={selectedOrgTypes}
            toggleViewType={toggleViewType}
            viewType={viewType}
            searchPlaceholder="Search Companies"
            onUserSearchClick={() => {}}
            downloadUrl={url}
            fileName={"Companies"}
            {...props}
          />
        )}
        filterObj={filterObj}
      />
    </>
  );
}
